// @core/api/endpoints/calendar/delete_calendar_event_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/calendar';

/**
 * Delete calendar event type
 * Deactivates a calendar event type definition. Existing calendar-aware entities of this type are not affected.
 */
export async function DeleteCalendarEventType(
  type_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendar-event-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
